
import { isEmpty, find } from 'lodash';
import { dom } from 'quasar';
import { mapGetters } from 'vuex';
import AdsApi from '../libs/ads-request/ads-api';
import { addActivity } from '../libs/helpers';
import ActivitiesList from '../views/budgets/ActivitiesList.vue';

const BUDGET_STATUS = [103, 104, 105, 107];

export default {
  name: 'ActivitiesComponent',
  components: {
    ActivitiesList,
  },
  props: {
    reset: Boolean,
    contracted: Boolean,
    shadow: Boolean,
  },
  data: () => ({
    redList: [],
    yellowList: [],
    greenList: [],
    isAuthorized: false,
    showTooltip: false,
    activitySelected: null,
    authorizedDisable: false,
    heightImage: 0,
    expand: false,
    responseComplete: [],
    showView: false,
    loaderMessage: 'Cargando presupuestos ...',
    loaderError: false,
    recordsWithBudget: 0,
  }),
  computed: {
    ...mapGetters('Activity', {
      parentSuperorderGreenAdditionalActivities: 'parentSuperorderGreenAdditionalActivities',
      parentSuperorderYellowActivities: 'parentSuperorderYellowActivities',
      parentSuperorderRedActivities: 'parentSuperorderRedActivities',
    }),

    desktop() {
      return this.$q.screen.gt.md;
    },
    tablet() {
      return this.$q.screen.lt.lg && this.$q.screen.gt.sm;
    },
    mobile() {
      return this.$q.screen.lt.md;
    },
    isThemeDefault() {
      return this.$session.get('brand') === '';
    },
    isThemeVolkswagen() {
      return this.$session.get('brand') === 'volkswagen';
    },
    isThemeSeat() {
      return this.$session.get('brand') === 'seat';
    },
    isThemeAudi() {
      return this.$session.get('brand') === 'audi';
    },

    greenActivities() {
      return [...this.greenList, ...this.parentSuperorderGreenAdditionalActivities];
    },

    yellowActivities() {
      return [...this.yellowList, ...this.parentSuperorderYellowActivities];
    },

    redActivities() {
      return [...this.redList, ...this.parentSuperorderRedActivities];
    },
  },
  watch: {
    reset() {
      this.activitySelected = null;
    },
  },
  mounted() {
    this.initialCharge();
  },
  methods: {
    isEmpty,
    afterCharge() {
      if (!this.mobile) {
        const { height } = dom;
        this.heightImage = height(document.getElementById('container-image'));
      }
    },
    async changeItem(item) {
      const clonedItem = item;

      if (this.authorizedDisable) this.authorizedDisable = false;

      clonedItem.accepted = !item.accepted;

      this.redList.map((activity) => {
        const redActivity = activity;
        if (redActivity.pack_id === item.pack_id) {
          redActivity.accepted = item.accepted;
        }
        return redActivity;
      });

      this.yellowList.map((activity) => {
        const yellowActivity = activity;
        if (yellowActivity.pack_id === item.pack_id) {
          yellowActivity.accepted = item.accepted;
        }
        return yellowActivity;
      });
    },
    getAdditionalActivities() {
      return AdsApi.getActivitiesBySuperOrder()
        .then(async (data) => {
          let authorized = true;
          const packIds = [];

          this.responseComplete = data;

          data.forEach((activity) => {
            const cloneActivity = activity;

            if (!BUDGET_STATUS.includes(+cloneActivity.view_status)
              && authorized === true) authorized = false;

            cloneActivity.show = true;

            let accepted = null;
            if (activity.accepted === 0) accepted = false;
            else if (activity.accepted === 1) accepted = true;

            cloneActivity.accepted = accepted;

            if (activity.activity_status_id === 3) {
              this.yellowList = addActivity(activity, this.yellowList, packIds);
            }
            if (activity.activity_status_id === 4) {
              this.redList = addActivity(activity, this.redList, packIds);
            }
            cloneActivity.disabled = true;
          });
        })
        .catch((error) => {
          throw error;
        });
    },
    getUnbudgetedActivities() {
      return AdsApi.getUnbudgetedActivities()
        .then((orders) => {
          orders.forEach((order) => {
            this.orderRempa(order);
          });
          this.redList = this.sortList(this.redList);
          this.yellowList = this.sortList(this.yellowList);
        })
        .catch((error) => {
          throw error;
        });
    },
    orderRempa(order) {
      order.activityClient.forEach((activity) => {
        const clonedActivity = activity;
        clonedActivity.show = false;

        if (clonedActivity.activity_status_id === 2 && clonedActivity.inventario === 0) {
          const object = find(
            this.greenList,
            (a) => a.order_activity_id === activity.order_activity_id,
          );
          if (object == null) this.greenList.push(activity);
        }

        if (clonedActivity.activity_status_id === 3) {
          const object = find(
            this.yellowList,
            (a) => a.order_activity_id === activity.order_activity_id,
          );
          if (object == null) this.yellowList.push(activity);
        }

        if (clonedActivity.activity_status_id === 4) {
          const object = find(
            this.redList,
            (a) => a.order_activity_id === activity.order_activity_id,
          );
          if (object == null) this.redList.push(activity);
        }
      });
    },
    redirectToReport(activity) {
      this.activitySelected = activity.order_activity_id;

      if (!this.mobile) {
        this.$emit('showDetail', {
          activity,
          heightImage: this.heightImage,
        });
      } else {
        this.$router.push({
          name: 'detail',
          params: {
            id: activity.order_activity_id,
            activity,
          },
        });
      }
    },
    async initialCharge() {
      try {
        await this.getAdditionalActivities();
        await this.getUnbudgetedActivities();
        this.showView = true;
      } catch (error) {
        this.loaderError = true;
      }
    },
    sortList(list) {
      return list.sort((a) => {
        if (a.evidence === 1) {
          return -1;
        }
        return 1;
      });
    },
  },
};
